import styled from "styled-components";

export const TitleContent = styled.h2`
  line-height: 31px;
  font-size: 24px;
  font-weight: 700;
  max-width: 288px;
  text-align: center;
  margin: auto;
`;